const isClosed = (string) => {
  const last = string.charCodeAt(string.length - 1);
  return (last - 0xac00) % 28 > 0;
};

export const Hangul = { isClosed };
